<template>
    <div class="form-field form-field--address">
        <div class="row">
            <div class="small-12 columns">
                <div class="form__group">
                    <label>Address 1</label>
                    <input
                        type="text"
                        placeholder="Address 1"
                        v-model="model.address_street_1">
                </div>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="small-12 columns">
                <div class="form__group">
                    <label>Address 2</label>
                    <input
                        type="text"
                        placeholder="Address 2"
                        v-model="model.address_street_2">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="small-4 columns">
                <div class="form__group">
                    <label>City</label>
                    <input
                        type="text"
                        placeholder="City"
                        v-model="model.address_city">
                </div>
            </div>
            <div class="small-4 columns">
                <div class="form__group">
                    <label>State</label>
                    <select v-model="model.address_state">
                        <option value="">-- Select --</option>
                        <option
                            v-for="state in states"
                            :value="state.abbreviation">
                            {{ state.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="small-4 columns">
                <div class="form__group">
                    <label>Zip</label>
                    <input type="number" v-model="model.address_zipcode" placeholder="Zip Code">
                </div>
            </div>
        </div>
        <br>
    </div>
</template>

<script>
    /**
     * Dependencies
     */
    import { stateOptions } from '../../../services/UtilityService'

    /**
     * Component
     */
    export default {
        name: 'address-field',
        props: {
            value: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                states: stateOptions,
                model: {}
            }
        },
        watch: {
            model: {
                deep: true,
                handler (updatedAddress) {
                    this.$emit('updated', updatedAddress)
                }
            }
        },
        created () {
            this.model = JSON.parse(JSON.stringify(this.value))
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/forms/AddressField.vue